/* import __COLOCATED_TEMPLATE__ from './question-multiple-choice-prompt.hbs.js'; */
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { A as EmberArray } from '@ember/array';
import { action, computed } from '@ember/object';
import { empty, readOnly } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import { feature } from '@square/ember-features/macros';
import { QuestionType } from '@square/dashboard-protos/models/squareup/feedbacksurveys/common';
import { QuestionResponse } from '@square/dashboard-protos/models/squareup/feedbacksurveys/survey_response';
let QuestionMultipleChoicePrompt = (_dec = computed('question.questionPrompt', 'onHandleTranslation'), _dec2 = readOnly('question.questionType'), _dec3 = readOnly('question.questionChoice'), _dec4 = empty('selectedChoices'), _dec5 = readOnly('isInputEmpty'), _dec6 = feature('dashboard/new_feedback_surveys'), _dec7 = computed('newFeedbackSurveysEnabled', 'hideRemindMeLaterButton'), _dec8 = computed('question.questionType', 'questionChoice', 'questionType', 'selectedChoices', 'onHandleTranslation'), _class = class QuestionMultipleChoicePrompt extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "eventstream", _descriptor, this);
    _defineProperty(this, "QuestionType", QuestionType);
    _defineProperty(this, "question", null);
    _defineProperty(this, "hideRemindMeLaterButton", false);
    _initializerDefineProperty(this, "questionType", _descriptor2, this);
    _initializerDefineProperty(this, "questionChoice", _descriptor3, this);
    _initializerDefineProperty(this, "isInputEmpty", _descriptor4, this);
    _initializerDefineProperty(this, "submitDisabled", _descriptor5, this);
    _initializerDefineProperty(this, "newFeedbackSurveysEnabled", _descriptor6, this);
  }
  get selectedChoices() {
    return EmberArray();
  }
  get questionPrompt() {
    return this.onHandleTranslation ? this.onHandleTranslation(this.question?.questionPrompt) : this.question?.questionPrompt;
  }
  get showRemindMeLaterButton() {
    return this.newFeedbackSurveysEnabled && !this.hideRemindMeLaterButton;
  }
  get questionOptions() {
    return this.questionChoice.map(choice => {
      const choiceValue = this.onHandleTranslation ? this.onHandleTranslation(choice.value) : choice.value;
      return {
        name: choiceValue,
        label: choiceValue,
        value: choice,
        selected: this.question?.questionType === QuestionType.MULTIPLE_SELECT ? this.selectedChoices.includes(choice) : this.selectedChoices === choice
      };
    });
  }
  singleSelectResponse() {
    const singleSelectResponse = QuestionResponse.SingleSelectResponse.create({
      choice: this.selectedChoices,
      questionChoice: this.question?.questionChoice
    });
    return QuestionResponse.create({
      questionToken: this.question?.questionToken,
      questionPrompt: this.question?.questionPrompt,
      singleSelectResponse
    });
  }
  multipleSelectResponse() {
    const multipleSelectResponse = QuestionResponse.MultipleSelectResponse.create({
      choice: this.selectedChoices,
      questionChoice: this.question?.questionChoice
    });
    return QuestionResponse.create({
      questionToken: this.question?.questionToken,
      questionPrompt: this.question?.questionPrompt,
      multipleSelectResponse
    });
  }
  singleSelectCheckboxChanged(value) {
    this.set('selectedChoices', value);
  }
  multiSelectCheckboxChanged(value) {
    if (value) {
      this.selectedChoices.addObject(value);
    } else {
      this.selectedChoices.removeObject(value);
    }
  }
  submitResponse() {
    const response = this.question?.questionType === QuestionType.MULTIPLE_SELECT ? this.multipleSelectResponse() : this.singleSelectResponse();
    this.survey.setResponseAndIncrementSurvey(response);
    this.set('selectedChoices', EmberArray());
  }
  handleRemindMeLater() {
    this.remindMeLater();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "eventstream", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "selectedChoices", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedChoices"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "questionPrompt", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "questionPrompt"), _class.prototype), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "questionType", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "questionChoice", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "isInputEmpty", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "submitDisabled", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "newFeedbackSurveysEnabled", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "showRemindMeLaterButton", [_dec7], Object.getOwnPropertyDescriptor(_class.prototype, "showRemindMeLaterButton"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "questionOptions", [_dec8], Object.getOwnPropertyDescriptor(_class.prototype, "questionOptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "singleSelectCheckboxChanged", [action], Object.getOwnPropertyDescriptor(_class.prototype, "singleSelectCheckboxChanged"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "multiSelectCheckboxChanged", [action], Object.getOwnPropertyDescriptor(_class.prototype, "multiSelectCheckboxChanged"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "submitResponse", [action], Object.getOwnPropertyDescriptor(_class.prototype, "submitResponse"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleRemindMeLater", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleRemindMeLater"), _class.prototype), _class);
export { QuestionMultipleChoicePrompt as default };